import { storage } from '@/lib/storage'

import { defaultLocale, Locale } from '@/i18n'
import { LOCALE_COOKIE_NAME } from './constants'

export function getUserLocale(): Locale {
  const locale = storage.get(LOCALE_COOKIE_NAME)
  return (locale as Locale) || defaultLocale
}

export function setUserLocale(locale: Locale) {
  storage.set(LOCALE_COOKIE_NAME, locale)
}

